import axiosPrivate from "../../../api/axiosPrivate";
import {
  ADD_CORPORATE_CUSTOMER,
  ADD_INDIVIDUAL_CUSTOMER,
  ADD_OTHER_DOCS,
  APPROVE_CUSTOMER,
  CLOSE_CUSTOMER,
  FILTERED_CORPERATE_CUSTOMERS,
  GET_ALL_CORPERATE_CUSTOMERS,
  GET_SEARCHED_CORP_CUSTOMER,
  GET_SINGLE_CUSTOMERS,
  REJECT_CUSTOMER,
  UPDATE_CORPORATE_CUSTOMER_BUSINESS_INFO,
  UPDATE_CORPORATE_CUSTOMER_CONTACT_INFO,
  UPDATE_CORPORATE_CUSTOMER_IDENTITY_INFO,
  UPDATE_CUSTOMER_BUSINESS_INFO,
  UPDATE_CUSTOMER_IDENTITY_INFO,
  UPDATE_CUSTOMER_NOK_INFO,
  GET_ALL_INDIVIDUAL_CUSTOMERS,
  UPDATE_CUSTOMER_PERSONAL_INFO,
  GET_SEARCHED_IND_CUSTOMER,
  GET_CUSTOMER_ACTIVE_POLICY,
  REACTIVATE_CUSTOMER,
  GET_ATTACHED_POLICY_CUSTOMER,
  GET_CUSTOMER_CLAIMS,
} from "./../../../api/constant";

// add individual customer
const addIndividualCustomer = async (customerData) => {
  const response = await axiosPrivate.post(
    `${ADD_INDIVIDUAL_CUSTOMER}`,
    customerData
  );
  return response.data;
};

// update individual customer personal info
const updateCustomerPersonalInfo = async (customerData) => {
  const response = await axiosPrivate.post(
    `${UPDATE_CUSTOMER_PERSONAL_INFO}/${customerData.id}`,
    customerData
  );
  return response.data;
};

// update individual customer identity info
const updateCustomerIdentityInfo = async (customerData) => {
  const response = await axiosPrivate.post(
    `${UPDATE_CUSTOMER_IDENTITY_INFO}/${customerData.id}`,
    customerData
  );
  return response.data;
};

// update individual customer business info
const updateCustomerBusinessInfo = async (customerData) => {
  const response = await axiosPrivate.post(
    `${UPDATE_CUSTOMER_BUSINESS_INFO}/${customerData.id}`,
    customerData
  );
  return response.data;
};

// update individual customer nok info
const updateCustomerNokInfo = async (customerData) => {
  const response = await axiosPrivate.post(
    `${UPDATE_CUSTOMER_NOK_INFO}/${customerData.id}`,
    customerData
  );
  return response.data;
};

// update corporate customer personal info
const updateCorporateCustomerBusinessInfo = async (customerData) => {
  const response = await axiosPrivate.post(
    `${UPDATE_CORPORATE_CUSTOMER_BUSINESS_INFO}/${customerData.id}`,
    customerData
  );
  return response.data;
};

// update corporate customer customer info
const updateCorporateCustomerContactInfo = async (customerData) => {
  const response = await axiosPrivate.post(
    `${UPDATE_CORPORATE_CUSTOMER_CONTACT_INFO}/${customerData.id}`,
    customerData
  );
  return response.data;
};

// update corporate customer identity info
const updateCorporateCustomerIdentityInfo = async (customerData) => {
  const response = await axiosPrivate.post(
    `${UPDATE_CORPORATE_CUSTOMER_IDENTITY_INFO}/${customerData.id}`,
    customerData
  );
  return response.data;
};

// add corporate customer
const addCorporateCustomer = async (customerData) => {
  const response = await axiosPrivate.post(
    `${ADD_CORPORATE_CUSTOMER}`,
    customerData
  );
  return response.data;
};
// get all corperate customers
const getCorperateCustomers = async (data) => {
  const response = await axiosPrivate.get(
    `${GET_ALL_CORPERATE_CUSTOMERS}?page=${data?.pageNumber}&office_id=${data?.office_id}`
  );

  return response.data?.corperate;
};

// get all individual customers
const getIndividualCustomers = async (data) => {
  const response = await axiosPrivate.get(
    `${GET_ALL_INDIVIDUAL_CUSTOMERS}?page=${data?.pageNumber}&office_id=${data?.office_id}`
  );

  return response.data;
};

// get single customer
const getSingleCustomer = async (payload) => {
  const response = await axiosPrivate.get(
    `${GET_SINGLE_CUSTOMERS}/${payload.id}?office_id=${payload.office_id}`
  );
  return response.data;
};

// approve Customer
const approveCustomer = async (data) => {
  const response = await axiosPrivate.get(
    `${APPROVE_CUSTOMER}/${data.id}?status_date=${data.status_date}`
  );
  return response.data;
};
// reject Customer
const rejectCustomer = async (data) => {
  const response = await axiosPrivate.get(
    `${REJECT_CUSTOMER}/${data.id}?status_reason=${data.status_reason}&status_date=${data.status_date}`
  );
  return response.data;
};
// close Customer
const closeCustomer = async (data) => {
  const response = await axiosPrivate.get(
    `${CLOSE_CUSTOMER}/${data.id}?status_date=${data.status_date}`
  );
  return response.data;
};
// reactivate Customer
const reactivateCustomer = async (id) => {
  const response = await axiosPrivate.get(`${REACTIVATE_CUSTOMER}/${id}`);
  return response.data;
};

const FilteredCorperateCustomers = async ({ staff_id, office_id }) => {
  const response = await axiosPrivate.post(
    `${FILTERED_CORPERATE_CUSTOMERS}?office_id=${office_id}&staff_id=${staff_id}`
  );
  const customers = {
    message: response.data?.message,
    ...response?.data?.customer_query1,
  };

  return customers;
};

const getCorperateCustomersSearch = async ({ office_id, searchBy }) => {
  const response = await axiosPrivate.get(
    `${GET_SEARCHED_CORP_CUSTOMER}?office_id=${office_id}&search=${searchBy}`
  );
  const customers = response?.data?.customers?.data?.filter(
    (item) => item.customer_type === "Corporate"
  );

  return { ...response?.data?.customers, data: customers };
};

const getIndividualCustomersSearch = async ({ office_id, searchBy }) => {
  const response = await axiosPrivate.get(
    `${GET_SEARCHED_IND_CUSTOMER}?office_id=${office_id}&search=${searchBy}`
  );

  const customers = response?.data?.customers?.data?.filter(
    (item) => item.customer_type === "Individual"
  );
  return { ...response?.data?.customers, data: customers };
};

const FilteredIndividualCustomers = async ({ staff_id, office_id }) => {
  const response = await axiosPrivate.post(
    `${FILTERED_CORPERATE_CUSTOMERS}?office_id=${office_id}&staff_id=${staff_id}`
  );
  const customers = {
    message: response.data?.message,
    ...response?.data?.customer_query2,
  };

  return customers;
};

const addOtherDocs = async (data) => {
  const response = await axiosPrivate.post(ADD_OTHER_DOCS, data);
  return response.data;
};

const getCustomerActivePolicy = async (data) => {
  const response = await axiosPrivate.get(
    `${GET_CUSTOMER_ACTIVE_POLICY}/${data}`
  );
  return response.data;
};

const getAttachPolicyCustomer = async ({ office_id, search }) => {
  const response = await axiosPrivate.get(
    `${GET_ATTACHED_POLICY_CUSTOMER}?office_id=${office_id}&search=${search}`
  );
  return response.data;
};
const getCustomerClaims = async (data) => {
  const response = await axiosPrivate.get(
    `${GET_CUSTOMER_CLAIMS}?page_number=${data.pageNumber}&customer_id=${data.customer_id}`
  );
  return response.data;
};

const customerService = {
  addIndividualCustomer,
  addCorporateCustomer,
  getCorperateCustomers,
  getIndividualCustomers,
  getSingleCustomer,
  updateCustomerPersonalInfo,
  updateCustomerIdentityInfo,
  updateCustomerBusinessInfo,
  updateCustomerNokInfo,
  updateCorporateCustomerBusinessInfo,
  updateCorporateCustomerContactInfo,
  updateCorporateCustomerIdentityInfo,
  approveCustomer,
  rejectCustomer,
  closeCustomer,
  reactivateCustomer,
  addOtherDocs,
  FilteredCorperateCustomers,
  FilteredIndividualCustomers,
  getCorperateCustomersSearch,
  getIndividualCustomersSearch,
  getCustomerActivePolicy,
  getAttachPolicyCustomer,
  getCustomerClaims,
};

export default customerService;
